import request from '@/utils/request'

export function loginByUsername(username, password) {
  const data = {
    account: username,
    'noLoading': true,
    password
  }
  return request({
    url: '/login',
    method: 'post',
    data
  })
}

export function logout() {
  return request({
    url: '/logout',
    method: 'get'
  })
}

export function getUserInfo(token) {
  return request({
    url: '/template/menu',
    method: 'get',
    params: { token }
  })
}

export function sendMobileMsg(username) {
  const data = {
    userAccount: username
  }
  return request({
    url: '/user/sendVerifyCode',
    method: 'post',
    data
  })
}

export function setEmailCode(username) {
  return new Promise((resolve, reject) => {
    resolve({
      code: 10001,
      message: '暂时不支持邮箱找回'
    })
  })
}

export function resetPassword(data) {
  return request({
    url: '/user/resetPassword',
    method: 'post',
    data
  })
}

export default {
  loginByUsername,
  logout,
  getUserInfo,
  sendMobileMsg,
  setEmailCode,
  resetPassword
}



// WEBPACK FOOTER //
// ./src/_app/wwka/src/api/login.js